module.exports = __webpack_public_path__ + "static/media/PaymentFail.5f9822c7.png";